import { Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { CoverLetterComponent } from '../cover-letter/cover-letter.component';
import { OrganizeDocumentsComponent } from '../organize-documents/organize-documents.component';
import { SupportLetterComponent } from '../support-letter/support-letter.component';
import { PlaceHolderDirective } from '../uscis-place-holder.directive';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { first } from 'rxjs/internal/operators/first';
import { updatei140StepStatus, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { ToastrService } from 'ngx-toastr';
import { MarkCleanFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { AppServicesLibraryService } from 'app-services-library';
import { GenerateFormsNewLibraryComponent } from 'generate-forms-new-library';

@Component({
  selector: 'i140-letter-generation',
  templateUrl: './letter-generation.component.html',
  styleUrls: ['./letter-generation.component.scss']
})
export class LetterGenerationComponent implements OnInit, OnDestroy {

  isLastTab: boolean;
  selectedItem: number;
  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  @ViewChild(PlaceHolderDirective, { static: true }) letterGenerationPlaceHolder: PlaceHolderDirective;
  observableSubscription$ = new Subject();
  data: any;
  showNext: boolean = false;
  showPrev: boolean = false;

  constructor(
    private store: Store<any>,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private componentFactoryResolver: ComponentFactoryResolver,
    private guard: DirtyFormGuard,
    private toastr: ToastrService,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.selectedItem = 0;
    this.isLastTab = false;
    this.data = this.dynamicDialogConfig?.data;
    this.showNext = this.data?.showNext; 
    this.showPrev = this.data?.showPrev;
  }

  ngOnInit(): void {
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.toggleControlsStatus();
      // this.handleFormsGeneration();
      this.handleCoverLetterSelection();
      // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
      //   this.updateStepStatus('INPROGRESS');
      // }
    });
  }

  updateStepStatus(status) {
    this.store.dispatch(updatei140StepStatus({ payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status), subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode }));
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  loadComponent(component) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    const viewContainerRef = this.letterGenerationPlaceHolder.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<any>(componentFactory);
    componentRef.instance.data = this.dynamicDialogConfig.data;
    componentRef.instance.inputData = this.dynamicDialogConfig.data;
  }

  handleFormsGeneration() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.isLastTab = false;
        this.selectedItem = 0;
        // this.loadComponent(GenerateFormsLibraryComponent);
        this.loadComponent(GenerateFormsNewLibraryComponent);
      }
      else {
        return false;
      }
    });
  }

  handleCoverLetterSelection() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.isLastTab = false;
        this.selectedItem = 1;
        this.loadComponent(CoverLetterComponent);
      }
      else {
        return false;
      }
    });

  }

  handleSupoortLetterSelection() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.isLastTab = false;
        this.selectedItem = 2;
        this.loadComponent(SupportLetterComponent);
      }
      else {
        return false;
      }
    });

  }


  handleOrganizeDocumentSelection() {
    this.isLastTab = true;
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.selectedItem = 3;
        this.loadComponent(OrganizeDocumentsComponent);
      }
      else {
        return false;
      }
    });

  }


  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }
}
